import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withKeys as _withKeys } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["type", "id", "placeholder", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tirscript-input", [
      _ctx.lightBg ? 'light-bg' : '',
      _ctx.noMargin ? 'no-mg' : '',
      _ctx.innerHasError ? 'has-error' : '',
    ]]),
    onKeyup: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onEnter && _ctx.onEnter(...args)), ["enter"]))
  }, [
    (!!_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _ctx.id,
          class: _normalizeClass([_ctx.requiredLabel ? 'required' : 'required-none'])
        }, _toDisplayString(_ctx.label) + ":", 11, _hoisted_1))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("input", {
      ref: "inputEl",
      style: _normalizeStyle(_ctx.style1),
      class: _normalizeClass(["form-control", [
        {
          disabled: _ctx.readonly,
          'has-error': _ctx.innerHasError,
          'has-icon': !!_ctx.icon & !_ctx.right,
          'has-icon-right': !!_ctx.icon & _ctx.right,
          'icon-left': _ctx.iconLeft,
        },
        { transformer: _ctx.transformer },
        { noBorder: _ctx.noBorder },
      ]]),
      type: _ctx.type,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.innerValue) = $event)),
      id: _ctx.id,
      placeholder: _ctx.placeholder,
      disabled: _ctx.readonly,
      onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.focused = true)),
      onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.focused = false))
    }, null, 46, _hoisted_2), [
      [_vModelDynamic, _ctx.innerValue]
    ]),
    (!!_ctx.icon & !_ctx.right)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(_ctx.icon + ' icon')
        }, null, 2))
      : (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(_ctx.icon + ' right'),
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.click && _ctx.click(...args)))
        }, null, 2)),
    (_ctx.showError)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: _normalizeClass(["error-msg", { hidden: !_ctx.showError || !_ctx.errorMessage }])
        }, _toDisplayString(_ctx.errorMessage), 3))
      : _createCommentVNode("", true)
  ], 34))
}